import React from 'react';

import { HStack, Text, Stack, Heading, Icon, useColorModeValue, Link } from '@ecoinvent/ui';
import { FiArrowRight } from 'react-icons/fi';

import AppCard from 'components/UI/AppCard';

import { GuideStep } from './types';

type Props = {
  step: GuideStep;
};

const GuideCard = ({ step: { icon, title, text, link } }: Props) => {
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const titleColor = useColorModeValue('gray.900', 'gray.100');
  const textColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <AppCard
      border="1px"
      borderColor={borderColor}
      shadow="none"
      key={title}
      p={4}
      py={0}
      borderRadius="md"
      h="100%"
      w="100%"
      _hover={{
        borderColor: 'gray.400',
        cursor: 'pointer',
      }}
      role="group"
      position="relative"
    >
      <Link href={link} isExternal _hover={{ textDecoration: 'none' }}>
        <HStack height="100%" justifyContent="space-between" py={4}>
          <HStack alignItems="start">
            {icon}
            <Stack justifyContent="space-between">
              <Heading fontSize="lg" fontWeight="bold" color={titleColor} _groupHover={{ textDecoration: 'underline' }}>
                {title}
              </Heading>
              <Text fontSize="sm" color={textColor} fontWeight="normal" _hover={{ textDecoration: 'none' }}>
                {text}
              </Text>
            </Stack>
          </HStack>
          <Icon
            as={FiArrowRight}
            color="green.500"
            opacity={0}
            _groupHover={{ opacity: 1 }}
            transition="opacity 0.1s"
            position="absolute"
            right={3}
            bottom={3}
          />
        </HStack>
      </Link>
    </AppCard>
  );
};

export default GuideCard;
